import { atom } from 'recoil';

export interface IsroSample {
    readonly number: number;
    readonly seriesUid: string;
    readonly registrationSopInstanceUid?: string;
}

export interface IsroResult {
    readonly jobId: string;
    readonly modelName: string;
    readonly referenceSeriesUid: string;
    readonly samples: readonly IsroSample[];
}

export const isroResultState = atom<IsroResult | null>({
    key: 'isroResultState',
    default: null,
});

export const isroSelectedSampleNumberState = atom<number | null>({
    key: 'isroSelectedSampleNumberState',
    default: null,
});
